import { defaultOrderBy } from './config';

export const defaultPageSettings = { order: 'asc', orderBy: defaultOrderBy };
export const settingType = 'contacts';
export const settingTypeP2P = 'contactP2P';
export const settingTypeDirect = 'contactsDirect';
export const title = 'Contacts';
